import { render, staticRenderFns } from "./Comp29t2.vue?vue&type=template&id=65eba874&scoped=true&"
import script from "./Comp29t2.vue?vue&type=script&lang=js&"
export * from "./Comp29t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp29t2.vue?vue&type=style&index=0&id=65eba874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eba874",
  null
  
)

export default component.exports